import { useQuery } from "@tanstack/react-query";
import {
  type DetailPeriod,
  type PositionDetailResponse,
  type SparklineResponse,
  otterfolioDetailApi,
} from "../lib/otterfolio-detail";

const baseKey = ["otterfolio"] as const;

export function useOtterfolioSparkline(positionId: string, days = 30) {
  return useQuery<SparklineResponse>({
    queryKey: [...baseKey, "sparkline", positionId, days],
    queryFn: () => otterfolioDetailApi.sparkline(positionId, days),
    staleTime: 60 * 60 * 1000, // 1 h — Quotes aendern sich hoechstens taeglich
  });
}

export function useOtterfolioPositionDetail(
  positionId: string,
  period: DetailPeriod,
  enabled = true,
) {
  return useQuery<PositionDetailResponse>({
    queryKey: [...baseKey, "detail", positionId, period],
    queryFn: () => otterfolioDetailApi.detail(positionId, period),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
